import UserThread from './UserThread.vue';
export default UserThread;
